import bem from 'utils/bem';

export const block = bem('youtube-partner-program-settings');
